"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SmallDirectionalTriangleIcon = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _generated = require("../../../generated");
const SmallDirectionalTriangleIcon = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    color,
    size,
    rotation,
    style,
    ...rest
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_generated.ArrowSmallDownIcon, (0, _extends2.default)({
    color: color,
    ref: ref,
    size: size,
    style: {
      transform: `rotate(${rotation + 180}deg)`,
      ...style
    }
  }, rest));
});
exports.SmallDirectionalTriangleIcon = SmallDirectionalTriangleIcon;
SmallDirectionalTriangleIcon.displayName = "SmallDirectionalTriangleIcon";
//# sourceMappingURL=SmallDirectionalTriangleIcon.js.map